/* istanbul ignore file */
import {
  UseQueryResult,
  keepPreviousData,
  useQuery,
} from '@tanstack/react-query';
import { api } from 'src/app/api/base';
import { URL_COMPUTERS } from 'src/app/api/urls';

interface useGetWindowsApplicationsArgs {
  deviceId: string;
  enabled?: boolean;
  params: {
    page?: number;
    per_page?: number;
    order_by?: string;
    search?: string;
    [k: string]: any;
  };
}

interface WindowsApplication {
  Name: string;
  Publisher: string;
  Version: string;
  Language: string;
  RegKey: string;
  Source: string;
  MsiProductCode: string;
  MsiPackageCode: string;
  ProgramId: string;
}

type WindowsApplicationsResponse = {
  last_sync_at: string;
  results: WindowsApplication[];
  count: number;
};

export function useGetWindowsApplications(args: useGetWindowsApplicationsArgs) {
  const { deviceId, params, enabled = true } = args;
  const { order_by, search, ...restParams } = params;

  return useQuery<WindowsApplicationsResponse>({
    queryKey: ['device-windows-applications', deviceId, params],
    queryFn: async () => {
      return (
        await api(`${URL_COMPUTERS}${deviceId}/apps`).get({
          ...(order_by && { order_by }),
          ...(search && { search }),
          ...restParams,
        })
      ).data;
    },
    placeholderData: keepPreviousData,
    enabled,
  });
}
